<template>
  <div>
    <div class="app-reg-notice">
      <div v-if="stepNum == 1 || stepNum == 2 || stepNum == 3">
        <strong>Cancel Registration -</strong>
        <span class="vehicle-type">{{ year }} {{ make }} {{ model != 'UNKNOWN' ? model : '' }} {{ plateNumber }} / {{ plateType }}</span>
      </div>
      <div v-if="stepNum == 4">
        <strong>Transaction Cart</strong>
      </div>
      <div v-if="stepNum == 5">
        <strong>{{ (store.state.guestLogin.totalBill && store.state.guestLogin.totalBill.totalSumFeeAmount > 0) ? 'Payment information' : 'Contact information' }}</strong>
      </div>
      <div v-if="stepNum == 6">
        <strong>Transaction confirmation</strong>
      </div>
    </div>
    <div>
      <SystemAlert />
    </div>
    <Stepper :step="stepNum" />
    <template v-if="stepNum == '1'"><GetReady @getStep="getStep" /></template>
    <template v-if="stepNum == '2'"><TransactionInfo @getStep="getStep" /></template>
    <template v-if="stepNum == '3'"><TransactionFee @getStep="getStep" /></template>
    <template v-if="stepNum == '4'"><TransactionCart @getStep="getStep" /></template>
    <template v-if="stepNum == '5'"><Payment @getStep="getStep" /></template>
    <template v-if="stepNum == '6'"><Confirmation @getStep="getStep" /></template>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import appConfig from '@/app.config';
import Stepper from '../../components/Stepper.vue';
import GetReady from './GetReady.vue';
import TransactionInfo from './TransactionInfo.vue';
import TransactionFee from './TransactionFee.vue';
import TransactionCart from '../renewReg/TransactionCart.vue';
import Payment from '../renewReg/Payment.vue';
import Confirmation from '../renewReg/Confirmation.vue';
import * as COMMONS from '../../store/_commons';
import SystemAlert from '@/components/SystemAlert';
import { useHead } from '@unhead/vue';

// Component's name and page metadata
useHead({
  title: `CancelReg | ${appConfig.shortName}`,
  meta: [
    {
      name: 'description',
      content: 'You can cancel your vehicle registrations'
    }
  ]
})

const store = useStore();

// Reactive data with ref
const year = ref(store.state.guestLogin.selectRenewRegistartion.year);
const make = ref(store.state.guestLogin.selectRenewRegistartion.make);
const model = ref(store.state.guestLogin.selectRenewRegistartion.model);
const plateNumber = ref(store.state.guestLogin.selectRenewRegistartion.plateNumber);
const plateType = ref(store.state.guestLogin.selectRenewRegistartion.plateType);

// Computed properties
const stepNum = computed(() => store.state.guestLogin.step);

// Methods
const getCancelRegistrationEligibility = (vehicleId) => store.dispatch(COMMONS.GUEST_CANCELREGISTRATION, vehicleId);

const getCancelRegistration = () => {
  // eslint-disable-next-line no-undef
  getCancelRegistrationEligibility(vehicleRegistrationId);
};

const getStep = (val) => {
  console.log(val);
};

const handlePopstate = () => {
  // This effectively blocks the back button by pushing the user forward one step
  history.go(1);
};

// Lifecycle hooks
onMounted(() => {
  window.history.replaceState(history.state, '', window.location.href);
  window.addEventListener('popstate', handlePopstate);
});

onUnmounted(() => {
  window.removeEventListener('popstate', handlePopstate);
});

defineExpose({
  getCancelRegistration,
});
</script>


<style scoped lang="scss">
  .app-reg-notice {
    max-width: 100%;
    background: var(--ri-light-blue);
    height: 100%;
    display: flex;
    padding: 1em;
    font-size: 20px;
    margin-bottom: 0px;
    margin-top: 5px;
    padding-left: var(--padding-horizontal);
    padding-right: var(--padding-horizontal);

    @media print {
      @page { size: 11in 8.5in; }
      background-color: var(--print-background);
    }
    .vehicle-type {
      margin-left: 5px;
    }
  }
  @media only screen and (max-width: 796px) {
    .app-reg-notice {
      display: block; 
      margin-top: 5px;
    }
  }
</style>
